var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Login")]),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v("Sign Up")]),_c('LoginInput')],1)}
var staticRenderFns = []

export { render, staticRenderFns }